import CryptoJS from 'crypto-js';

const key = 'byz9VFNtbRQM0yBODcCb1lrUtVVH3D3x';
const iv = 'X05IGQ5qdBnIqAWD';

export function decrypt(encryptedData) {
  try {
    // Convert the hex string to WordArray
    const encryptedHex = CryptoJS.enc.Hex.parse(encryptedData);

    // Create key and IV
    const keyWordArray = CryptoJS.enc.Utf8.parse(key);
    const ivWordArray = CryptoJS.enc.Utf8.parse(iv);

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedHex }, keyWordArray, {
      iv: ivWordArray,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Convert to string and parse JSON
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
}
